import Vue from 'vue'
import Vuex from 'vuex'
import { vuexfireMutations } from 'vuexfire'

import auth from './auth';
import recipe from './recipe';
import recipes from './recipes';
import tagged from './tagged';
import meals from './meals';
import meal from "./meal";
import users from './users';

Vue.use(Vuex)

export default new Vuex.Store({
  mutations: {
    // other mutations
    ...vuexfireMutations
  },
  modules: {
    auth,
    recipe,
    recipes,
    tagged,
    meals,
    meal,
    users
  }
});
